var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"wrap"},[_c('div',{staticClass:"content"},[_c('title',[_vm._v("欢迎来到广州市燊业互联网有限公司")]),_vm._v(" "),_c('div',{staticClass:"sign-wrap"},[_c('router-link',{staticClass:"sign",attrs:{"to":"/sign"}},[_vm._v("注册")]),_c('router-link',{staticClass:"login",attrs:{"to":"/login"}},[_vm._v("登录")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14979176","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginNavigator.vue
// module id = null
// module chunks = 